module.exports = __webpack_public_path__ + "static/media/Georgia.017c9f13.png";